/*!
 * devextreme-vue
 * Version: 18.2.3
 * Build date: Thu Nov 08 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @deprecated Use 'devextreme-vue/data-grid' file instead */
__export(require("../data-grid"));
var data_grid_1 = require("../data-grid");
exports.default = data_grid_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme-vue/ui/data-grid.js
// module id = 8jSX
// module chunks = 0